module.exports = __webpack_public_path__ + "img/area-4-video1-cover.fa942cf.jpg";